import Handlebars from 'handlebars';

import DealRoomAttachmentsTemplate from 'src/templates/dealRoom/DealRoomTemplate.handlebars.js';
import DealRoomCard from 'src/templates/dealRoom/DealRoomCard.handlebars';
import DealRoomCTATemplate from 'src/templates/dealRoom/DealRoomCTA.handlebars.js';
import DealRoomLinkTemplate from "src/templates/dealRoom/DealRoomLink.handlebars.js";

Handlebars.registerHelper('helperMissing', function() {
  var options = arguments[arguments.length - 1];
  return 'MISSING VALUE: ' + options.name;
}); 

Handlebars.registerHelper('placeholder', function(value, placeholder) {
  if(value !== undefined){
    return value;
  }

  var result = '<span class="placeholder">' + placeholder + '</span>';
  return new Handlebars.SafeString(result);
}); 

export default class DealRoomWidgetManager{
  constructor() {
    this.widgets = [{
      id: 'company.logo',
      name: 'Company Logo',
      type: 'widget'
    },{
      id: 'company.branding',
      name: 'Company Branding',
      type: 'widget'
    },{
      id: 'company.name',
      name: 'Company Name',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['company.name'];
      }  
    },{
      id: 'collection.name',
      name: 'Deal Room Name',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['collection.name'];
      }
    },{
      id: 'collection.assets',
      name: 'Assets Count',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['collection.assets'];
      }
    },{
      id: 'contact.firstname',
      name: 'First Name',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['contact.firstname'];
      }
    },{
      id: 'contact.lastname',
      name: 'Last Name',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['contact.lastname'];
      }
    },
    {
      id: 'signature.description',
      name: 'Signature',
      type: 'variable',
      getValue: (parameters) => {
        return parameters['emailSignature'];
      }
    },
    {
      id: 'dealRoom.card',
      name: 'Deal Room Card',
      type: 'widget',
      render: (node, parameters) => {
        if(node == null){
          node = document.createElement('div');
          node.classList.add('mceNonEditable', 'widget');
          node.setAttribute('data-widget-id', 'dealRoom.card');
        }

        var html = DealRoomCard(parameters);
        node.innerHTML = html;

        return node;
      }
    },{
      id: 'assets.grid',
      name: 'Assets Grid',
      type: 'widget',

      render: (node, parameters) => {
        
        if(node == null){
          node = document.createElement('div');
          node.classList.add('mceNonEditable', 'widget');
          node.setAttribute('data-widget-id', 'assets.grid');
          node.setAttribute('contenteditable', false);
        }

        let assets = parameters.assets || [];
        let isEmailTemplate = parameters.isEmailTemplate || false;
        let sections = parameters.sections || [];
        var html =  DealRoomAttachmentsTemplate(parameters);
        
        node.innerHTML = html;
        node.setAttribute('contenteditable', false);

        return node;
      },

      convertToTemplate(node){
        if(!node){
          return;
        }

        var anchorNodes = node.querySelectorAll('a[data-widget-placeholder]');
  
        if(anchorNodes && anchorNodes.length > 0){
          for (var i = 0; i < anchorNodes.length; i++) {
            var element = anchorNodes[i];
            var placeholder=null;
            placeholder="\{{contact.url}}/deal-room/\{{share.id}}"           
            element.setAttribute('href', placeholder);
            element.removeAttribute('data-widget-placeholder');
          }
        }

        var imgNodes = node.querySelectorAll('img[data-widget-placeholder]');
  
        if(imgNodes && imgNodes.length > 0){
          for (var i = 0; i < imgNodes.length; i++) {
            var element = imgNodes[i];
              placeholder = `\{{apiUrl}}/shared_url/\{{share.id}}/asset/\{{share.assets.[${i}].id}}/icon`
            element.src = placeholder;
            element.removeAttribute('data-widget-placeholder');
          }
        }
      }
    },{
      id: 'asset.card',
      name: 'Asset Card',
      type: 'widget',
      template: '',
      render: (node, parameters) => {
          
      }
    },{
      id: 'dealRoom.cta',
      name: 'Deal Room CTA',
      type: 'widget',

      render: (node, parameters) => {
        
        if(node == null){
          node = document.createElement('div');
          node.classList.add('widget', 'collectionCTA');
          node.setAttribute('data-widget-id', 'dealRoom.cta');
          
          var html =  DealRoomCTATemplate(parameters);
          node.innerHTML = html;          
        }

        return node;
      },

      convertToTemplate(node){

        if(!node){
          return;
        }

        var anchorNodes = node.querySelectorAll('a[data-widget-placeholder]');
  
        if(anchorNodes && anchorNodes.length > 0){
          for (var i = 0; i < anchorNodes.length; i++) {
            var element = anchorNodes[i];
            var placeholder = `{{contact.url}}/deal-room/{{share.id}}`;
            element.setAttribute('href', placeholder);
            element.removeAttribute('data-widget-placeholder');
          }
        }
      }
    },{
      id: 'dealRoom.link',
      name: 'Deal Room Link',
      type: 'widget',

      render: (node, parameters) => {
        if(node == null){
          node = document.createElement('div');
          node.classList.add('widget', 'collectionLink');
          node.setAttribute('data-widget-id', 'dealRoom.link');
        
          var html =  DealRoomLinkTemplate(parameters);
          node.innerHTML = html;
        }
        
        return node;
      },

      convertToTemplate(node){
        if(!node){
          return;
        }

        var anchorNodes = node.querySelectorAll('a[data-widget-placeholder]');
  
        if(anchorNodes && anchorNodes.length > 0){
          for (var i = 0; i < anchorNodes.length; i++) {
            var element = anchorNodes[i];
            var placeholder = `\{{contact.url}}/deal-room/\{{share.id}}`;
            element.setAttribute('href', placeholder);
            element.removeAttribute('data-widget-placeholder');
          }
        }
      }
    },{
      id: 'signature.description',
      name: 'Signature Description',
      type: 'widget',
      render: (node, parameters) => {
        if(node == null){
          node = document.createElement('div');
          var html = parameters.emailSignature;
          node.innerHTML = html;
        }
        
        return node;
      }
    }];
  }

  variables(){
    return this.widgets.filter((item) => {
      return item.type == 'variable'
    })
  }

  variable(id){
    return this.widgets.find((item) => {
      return item.id == id && item.type == 'variable';
    })  
  }

  widgets(){
   return this.widgets.filter((item) => {
      return item.type == 'widget'
    }) 
  }

  widget(id){
    return this.widgets.find((item) => {
      return item.id == id && item.type == 'widget';
    })  
  }

  render(template, parameters, showPlaceholders){
    if(showPlaceholders){
      template = this.processHandlebarTemplate(template);  
    }

    var compiledTemplate = Handlebars.compile(template, {knownHelpersOnly: false, strict: false, assumeObjects: true});
    var html = compiledTemplate(parameters);

    return html;
  }

  getRawTemplate(html){
    var node = document.createElement('div');
    node.innerHTML = html;

    var variableNodes = node.querySelectorAll('.variable[data-original-variable]');
  
    if(variableNodes && variableNodes.length > 0){
      for (var i = 0; i < variableNodes.length; i++) {
        var element = variableNodes[i];

        var nodeValue = element.getAttribute('data-original-variable');
        var div = document.createElement('div');

        var appliedStyle = element.getAttribute("style");
        if(appliedStyle){
          var span = document.createElement('span');
          span.setAttribute('style', appliedStyle);
          span.innerHTML = nodeValue;

          div.appendChild(span);
        }else{
          div.innerHTML = nodeValue;  
        }
        
        var child;
        while ((child = div.lastChild)) {
          element.parentNode.insertBefore(child, element.nextSibling);
        }

        // remove HTML variable node
        // because we now have an text representation of the variable
        element.parentNode.removeChild(element);
      }
    }

    var widgetNodes = node.querySelectorAll('.widget[data-widget-id]');
  
    if(widgetNodes && widgetNodes.length > 0){
      for (var i = 0; i < widgetNodes.length; i++) {
        var element = widgetNodes[i];

        var widgetID = element.getAttribute('data-widget-id');
        var widget = this.widget(widgetID);

        if(widget){
          widget.convertToTemplate(element);
        }
      }
    }
    
    return node.innerHTML;
  }

  isWidgetInserted(html) {
    var node = document.createElement('div');
    node.innerHTML = html;

    var widgetNodes = node.querySelectorAll('.widget[data-widget-id]');

    return widgetNodes.length > 0;
  }

  processHandlebarTemplate(html){
    var node = document.createElement('div');
    node.innerHTML = html;

    var walkDOM = function (node,func) {
      func(node);
      node = node.firstChild;
      while(node) {
          walkDOM(node,func);
          node = node.nextSibling;
      }
    };    

    var manager = this;
    var stringVariableRegex = new RegExp('{{' + '([a-z. _]*)?' + '}}', 'g');
    var nodeList = [];

    walkDOM(node, (n) => {
      if (n.nodeType == 3 && n.nodeValue && stringVariableRegex.test(n.nodeValue)) {
        nodeList.push(n);
      }
    });

    for (var i = 0; i < nodeList.length; i++) {
      var element = nodeList[i];
      var nodeValue = nodeList[i].nodeValue;

      nodeValue = nodeList[i].nodeValue.replace(stringVariableRegex, function(value){
        var cleanValue = value.replace(/[^a-zA-Z0-9._]/g, "");
        
        var variable = manager.variable(cleanValue);
        if(variable){
          return '{{placeholder ' + cleanValue + ' ' + '"'+ variable.name +'"}}'
        }

        return '\\{{' + cleanValue + '}}';
      });

      var div = document.createElement('div');
      div.innerHTML = nodeValue;

      var child;
      while ((child = div.lastChild)) {
          element.parentNode.insertBefore(child, element.nextSibling);
      }

      element.parentNode.removeChild(element);
    }


    return node.innerHTML;
  }
}
